import './App.css';
import ScreenRouter from '../ScreenRouter/ScreenRouter';
import { CookiesProvider } from 'react-cookie';
import { useCookies } from 'react-cookie';

function App() {
    
    // const [cookies, setCookie] = useCookies(['email', 'access_token'])

    // if ((cookies.access_token === undefined
    //     || cookies.access_token === '') && window.location.pathname != '/login') {
    //     window.location.href = "/login";
    // }

    // validate auth token with server

    return (
        <CookiesProvider>
            <ScreenRouter />
        </CookiesProvider>
    );
}

export default App;
